import { useMutation, useQueryClient } from "@tanstack/react-query";
import { voidPurchasePayment } from "api/purchasePayment.api";
import {
  invalidatePurchasePaymentSide,
  invalidateExpenseSide,
} from "lib/cacheInvalidation";

export const useVoidPurchasePayment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }) => voidPurchasePayment(id, { reason }),
    onSuccess: () => {
      invalidatePurchasePaymentSide(queryClient);
      invalidateExpenseSide(queryClient);
    },
  });
};
